/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { Grid, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, Typography } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const OpenModalReject = (props) => {
  const [content, setContent] = useState({});
  const [zPos, setZPos] = useState(45)
  const history = useHistory();
  let info = [];

  useEffect(() => {
    setContent(props.contentModal);
  }, []);

  if (content["content"]) {
    info = [
      { title: "Estatus: ", data: content["status"] },
      { title: "Motivo de Rechazo: ", data: content["content"]["reason"] },
      { title: "Comentarios: ", data: content["content"]["cooment"] },
      { title: "Archivos: ", data: Object.values(content["content"]["files"]) },
    ];
  }

  const download = async (item) => {
    let data = item.split("gs://docs-indigo-next-dev/")[1]
    props.changeLoader(true);
    setZPos(-1)

    let request = await API.service( "downloadFile", data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.data.data.response == "OK" && request.status == 200) {
      if (request.data.data.content) {
        let url = request.data.data.content;
        window.open(url, "_blank");

        props.changeLoader(false);
        props.changeAlert(true, "success", "Archivo descargado con éxito");
        setZPos(45)
        return;
      }
    } else {
      props.changeLoader(false);
      props.changeAlert(true, "error", "Error en descarga de archivo");
      setZPos(45)
    }
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(false)}>
        <DialogTitle>
          {content["title"]}
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>        
        <DialogContent>
            {content["content"] &&
              info.map((i) => {
                return (
                  <Grid container spacing={2} key={i.title} sx={{marginTop: "-8px !important"}}>
                    <Grid item xs={4} >{i.title}</Grid>
                    <Grid item xs={8}>
                      { typeof(i.data) !== "object" ?
                        (i.data?.length > 0 || i.data ? i.data : "N/A") : (                           
                          i.data?.length > 0 ? (i.data?.map((file, index) => {
                            return (
                              <Typography sx={{marginBottom: "15px"}}><a key={`file-${index}`} onClick={() => download(file)}>{file}</a>
                              </Typography>
                            )
                          })) : "N/A"
                        )
                      }
                    </Grid>
                  </Grid>
                )
            })}
        </DialogContent>
        <DialogActions>					
          <Button variant="contained" onClick={closelightbox}>Aceptar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>
  );
};

export default OpenModalReject;
